import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-form-date',
  styleUrls: ['form-date.component.scss'],
  templateUrl: './form-date.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent, NgbDatepickerModule],
})
export class FormDateComponent extends FieldBaseComponent {}
